module.exports = __webpack_public_path__ + "static/media/business-info.9a90fe4c.png";